import GolEventHandler from "./gol-event-handler";
class SelectionStoreChangesService {
  public subscribers: Array<GolEventHandler> = [];
  static service: SelectionStoreChangesService | undefined;
  static get(): SelectionStoreChangesService {
    if (!this.service) {
      this.service = new SelectionStoreChangesService();
    }
    return this.service;
  }
  public registerListener = (
    componentName: string,
    observableStoreProps: Array<string>,
    useCallbackOnChanged: () => void
  ) => {
    this.subscribers.push(
      new GolEventHandler(
        componentName,
        observableStoreProps,
        useCallbackOnChanged
      )
    );
  };

  public unregisterListener = (component: string) => {
    this.subscribers = this.subscribers.filter(
      (subscriber) => subscriber.componentName !== component
    );
  };

  public dispatch = (observeProps: string) => {
    this.subscribers.forEach((subscriber) => subscriber.dispatch(observeProps));
  };
}

export const selectionStoreChangesService = SelectionStoreChangesService.get();
